export function parsePdf(rawPdf) {
  let pdf = new Uint8Array(rawPdf.length);
  for (let i = 0; i < rawPdf.length; i++) {
    pdf[i] = rawPdf.charCodeAt(i);
  }
  return pdf;
}

/**
 * The bytes of a downloaded document, as the viewer wants them.
 *
 * The legacy transport answered a base64 string inside a JSON envelope, which
 * `parsePdf` unpacked one `charCodeAt` at a time; the REST endpoints stream the
 * file, so the response is already a `Blob` and the round trip through base64 is
 * gone. Both viewers still take a `Uint8Array`, so that is what this returns.
 *
 * `arrayBuffer()` is the modern spelling and `FileReader` the fallback: jsdom
 * ships `Blob` without `arrayBuffer()` in the version this project's jest preset
 * pins, so a test would fail on a method the browser has had for years.
 */
export function bytesFromBlob(blob) {
  if (!blob) {
    return Promise.reject(new Error('The document came back empty.'));
  }

  if (typeof blob.arrayBuffer === 'function') {
    return blob.arrayBuffer().then((buffer) => new Uint8Array(buffer));
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(new Uint8Array(reader.result));
    reader.onerror = () => reject(reader.error || new Error('The document could not be read.'));
    reader.readAsArrayBuffer(blob);
  });
}
